var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_shared-key.js
// module id = 362
// module chunks = 168707334958949